import React__default from 'react';
import classNames from 'classnames';
import Styles from '../common.module.scss.js';
import { ReactComponent as SvgAngleRight } from '../../../icons/AngleRight.svg.js';

const RightBtn = ({ className, style, iconClassName, iconStyle, onClick, disabled = false }) => {
    return (React__default.createElement("span", { className: classNames(Styles.main, Styles.left, disabled && Styles.disabled, className), style: style, onClick: onClick },
        React__default.createElement("span", { className: classNames(Styles.icon, iconClassName), style: iconStyle },
            React__default.createElement(SvgAngleRight, null))));
};

export { RightBtn as default };
//# sourceMappingURL=LeftBtn.js.map
